var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueTypeaheadBootstrap',{class:[_vm.stateClass],attrs:{"data":_vm.categorias,"serializer":_vm.getOptionText,"placeholder":_vm.placeholder,"showOnFocus":true,"size":_vm.size},on:{"hit":_vm.handleSelect},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }